<template>
  <div
    :class="['expandable-list', className, {'style-border': border}]">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ExpandableList",
  props: {
    className: {
      type: String,
    },
    border: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="scss" scoped>
.style-border {
  border: 1px solid #dadada;
}
</style>
